// 短信相关API接口
import request from '@/utils/request'

/**
 * 获取验证码
 * @param data
 * @returns {*}
 */
export function sendMsg(data) {
    return request({
        url: '/sms',
        method: 'post',
        data
    })
}
